import axios from 'axios';
import { baseURL } from './api';

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class ProductService {
  static baseURL = baseURL;
  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || ProductService.resourcePath || ProductService.baseURL;
  };

  async getProductGroupsByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/productGroups`,
      { headers },
    );
    return data;
  }

  async getOTCByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/oneTimeChargeGroups`,
      { headers },
    );
    return data;
  }

  async getInstallationChargesByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/oneTimeChargeGroups?type=installation`,
      { headers },
    );
    return data;
  }

  async updateProductGroupsById(pgid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.put(
      `${this.getBaseURL()}${apiVersion}/productGroups/${pgid}`,
      productGroups,
      { headers },
    );
    return res;
  }

  async updateOTCProductGroupsById(pgid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.put(
      `${this.getBaseURL()}${apiVersion}/productGroups/oneTimeChargeGroups`,
      productGroups,
      { headers },
    );
    return res;
  }

  async updateInstallationGroupsById(pgid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.put(
      `${this.getBaseURL()}${apiVersion}/productGroups/oneTimeChargeGroups?type=installation`,
      productGroups,
      { headers },
    );
    return res;
  }

  async insertProductGroupsIntoCompany(cid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/productGroups`,
      productGroups,
      { headers },
    );
    return res;
  }

  async insertOTCGroup(tid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.post(
      `${this.getBaseURL()}${apiVersion}/oneTimeCharges?templateId=${tid}`,
      productGroups,
      { headers },
    );
    return res;
  }

  async insertInstallationGroupsIntoCompany(tid, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.post(
      `${this.getBaseURL()}${apiVersion}/oneTimeCharges?templateId=${tid}`,
      productGroups,
      { headers },
    );
    return res;
  }

  async deleteProductGroup(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.delete(`${this.getBaseURL()}${apiVersion}/productgroups/${id}`, {
      headers,
    });
    return res;
  }

  async deleteOtcProductGroup(cid, pid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/oneTimeChargeGroups/${pid}`,
      { headers },
    );
    return res;
  }

  async deleteInstProductGroup(cid, pid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const res = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/oneTimeChargeGroups/${pid}?type=installation`,
      { headers },
    );
    return res;
  }

  async getOneTimeTemplates(type) {
    const mock = [
      {
        templateName: 'epik template',
        deleted: false,
        productGroupCharges: [
          {
            _id: '112233',
            groupName: 'Life Safety Analog Line',
            deleted: false,
            multiSelect: true,
            company: '5c0fa292845f46059f1c1ce1',
            products: [
              {
                name: 'Burglar Alarm Line',
                description: 'Burglar Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Elevator Line',
                description: 'Elevator Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Fire Alarm Line',
                description: 'Fire Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Security Alarm Line',
                description: 'Security Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
            ],
          },
          {
            _id: '556677',
            groupName: 'Life Safety Analog Line',
            deleted: false,
            multiSelect: true,
            company: '5c0fa292845f46059f1c1ce1',
            products: [
              {
                name: 'Burglar Alarm Line',
                description: 'Burglar Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Elevator Line',
                description: 'Elevator Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Fire Alarm Line',
                description: 'Fire Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        templateName: 'epik template 2',
        deleted: false,
        productGroupCharges: [
          {
            _id: '112233',
            groupName: 'Life Safety Analog Line 2',
            deleted: false,
            multiSelect: true,
            company: '5c0fa292845f46059f1c1ce1',
            products: [
              {
                name: 'Burglar Alarm Line',
                description: 'Burglar Alarm Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
              {
                name: 'Elevator Line',
                description: 'Elevator Line',
                priceList: [
                  {
                    desc: '24 Months',
                    price: 59.95,
                    key: '24',
                  },
                  {
                    desc: '36 Months',
                    price: 49.95,
                    key: '36',
                  },
                  {
                    desc: '48 Months',
                    price: 44.95,
                    key: '48',
                  },
                  {
                    desc: '60 Months',
                    price: 39.95,
                    key: '60',
                  },
                ],
              },
            ],
          },
        ],
      },
    ];
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/oneTimeTemplates?type=${type}`,
      { headers },
    );
    return data;
  }

  async addOneTimeTemplates(type, template) {
    console.log(type, 'TYPE:');
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/oneTimeTemplates?type=${type}`,
      template,
      { headers },
    );
    return data;
  }

  async getOTTById(type, id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/oneTimeTemplates/${id}?type=${type}`,
      { headers },
    );
    return data;
  }

  async insertProductGroupById(tId, productGroups) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.post(
      `${this.getBaseURL()}${apiVersion}/productGroups?templateId=${tId}`,
      productGroups,
      { headers },
    );
    return res;
  }

  async deleteProductGroupByTemplateId(pgId, tId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/productgroups/${pgId}?templateId=${tId}`,
      {
        headers,
      },
    );
    return res;
  }

  async deleteOtcProductGroupByTemplateId(pgId, tId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/oneTimeCharges/${pgId}?templateId=${tId}`,
      {
        headers,
      },
    );
    return res;
  }
}

export default ProductService;
